// Hub-assigned module access (empty list = full access).
export const MODULE_ROUTES = {
  auto_job_card: { path: '/auto-jobcard', label: 'Auto Job Card' },
  event_logs: { path: '/rpi-edge', label: 'Event Logs' },
};

export const moduleRoutes = (user) =>
  (user?.allowed_modules || []).filter(k => MODULE_ROUTES[k]).map(k => ({ key: k, ...MODULE_ROUTES[k] }));

export const isPathAllowed = (user, path) => {
  const routes = moduleRoutes(user);
  return !routes.length || routes.some(r => path === r.path || path.startsWith(r.path + '/'));
};
